module.exports = __webpack_public_path__ + "img/person-img4.f7c6d0a5.png";